import titleReducer from "./titleReducer"
import { combineReducers } from "redux"

const rootReducer = combineReducers({
    title: titleReducer
})

export default rootReducer;